export enum GapTypeEnum {
  Access = "access",
  Servicing = "servicing",
  AccessAndServicing = "accessAndServicing",
}